import { render } from "./HomePageBanner.vue?vue&type=template&id=6652c792&scoped=true"
import script from "./HomePageBanner.vue?vue&type=script&lang=js"
export * from "./HomePageBanner.vue?vue&type=script&lang=js"

import "./HomePageBanner.vue?vue&type=style&index=0&id=6652c792&lang=scss&scoped=true"

import exportComponent from "/home/apps/jingo_web_full/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6652c792"]])

export default __exports__